import { motion } from 'framer-motion'
import { item } from "../homepage/Section1"
import { IconSparkles } from '@tabler/icons-react'

const Section7 = () => {
  return (
    <div className='s7-partner' style={{backgroundColor : "#FFF6F3"}}>
        <div className='f-width m-auto'>
            <p className="s4-h-text text-center"><IconSparkles className="color-brand animate__animated animate__bounceIn animate__infinite animate__slower" width="34" height="34" /> How it works?</p>
            <motion.div variants={item} whileInView="visible" initial="hidden" className='row'>
                <div className='col-sm-12 col-lg-3'>
                    <div className='s7-p-card-content' style={{borderBottom: "2px solid #FF5E2C"}}>
                        <div className='bdr-top'></div>
                        <div className='brand-bg rounded-pill text-white step-1'>01</div>
                        <p className='s6-card-t1'>Apply:</p>
                        <p className='s6-card-t2'>Fill out the form below. Tell us about your audience and how you intend to refer clients.</p>
                    </div>
                </div>
                <div className='col-sm-12 col-lg-3'>
                    <div className='s7-p-card-content' style={{borderBottom: "2px solid #FF5E2C50"}}>
                        <div className='bdr-top'></div>
                        <div className='brand-bg rounded-pill text-white step-2'>02</div>
                        <p className='s6-card-t1'>Connect:</p>
                        <p className='s6-card-t2'>We'll schedule a quick call to align on goals, partner type, pricing flexibility and next steps.</p>
                    </div>
                </div>
                <div className='col-sm-12 col-lg-3'>
                    <div className='s7-p-card-content' style={{borderBottom: "2px solid #FF5E2C"}}>
                        <div className='bdr-top'></div>
                        <div className='brand-bg rounded-pill text-white step-3'>03</div>
                        <p className='s6-card-t1'>Onboard:</p>
                        <p className='s6-card-t2'>Once approved, you’ll get access to co-branded or white-label assets, sales training, and everything needed to start offering Voosh under your brand.</p>
                    </div>
                </div>
                <div className='col-sm-12 col-lg-3'>
                    <div className='s7-p-card-content' style={{borderBottom: "2px solid #FF5E2C50"}}>
                        <div className='bdr-top'></div>
                        <div className='brand-bg rounded-pill text-white step-4'>04</div>
                        <p className='s6-card-t1'>Refer & Earn:</p>
                        <p className='s6-card-t2'>Refer clients or resell under your own brand. Earn through commissions or margin-based pricing—whatever fits your partner model.</p>
                    </div>
                </div>
            </motion.div>
        </div>
    </div>
  )
}

export default Section7